/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Hero_Lead_BeforeInputs */

const es_landing_hero_lead_before = /** @type {(inputs: Landing_Hero_Lead_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahora puedes alquilar tu barco en `)
};

const gl_landing_hero_lead_before = /** @type {(inputs: Landing_Hero_Lead_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agora podes alugar o teu barco na `)
};

const en_landing_hero_lead_before = /** @type {(inputs: Landing_Hero_Lead_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can now rent out your boat on the `)
};

/**
* | output |
* | --- |
* | "You can now rent out your boat on the" |
*
* @param {Landing_Hero_Lead_BeforeInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_hero_lead_before = /** @type {((inputs?: Landing_Hero_Lead_BeforeInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Hero_Lead_BeforeInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_hero_lead_before(inputs)
	if (locale === "en") return en_landing_hero_lead_before(inputs)
	return es_landing_hero_lead_before(inputs)
});